import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Wizard from "@/pages/Wizard";
import Results from "@/pages/Results";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            {/* Legacy admin login route redirects to unified /login */}
            <Route path="/admin/login" element={<Navigate to="/login" replace />} />

            <Route path="/" element={<ProtectedRoute><Landing /></ProtectedRoute>} />
            <Route path="/wizard/:category" element={<ProtectedRoute><Wizard /></ProtectedRoute>} />
            <Route path="/results" element={<ProtectedRoute><Results /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute requireAdmin><AdminDashboard /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position={window.innerWidth < 640 ? "bottom-center" : "top-right"} />
      </AuthProvider>
    </div>
  );
}

export default App;
